export default __webpack_public_path__ + "ddbbb17642eb55cdf4ddc452ffc4e180.png";